<template>
  <div class="row">
    <div class="col-xl-12">
      <router-view />

      <div
        v-show="$route.path == '/AgentStockOverdue'"
        class="kt-portlet kt-portlet--mobile" >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-chart-bar"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <!-- Row 1 -->

               <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
                <div class="form-group mb-3">
                  <label class="mb-1">ชื่อตัวแทนจำหน่าย:</label>
                  <treeselect
                    v-model="agentCode"
                    :multiple="true"
                    :options="agentCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>


              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
                <div class="form-group mb-3">
                  <label class="mb-1">ชื่อตัวแทนจำหน่าย(Group):</label>
                  <treeselect
                    v-model="headAgentCode"
                    :multiple="true"
                    :options="headAgentCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

               <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
                <div class="form-group mb-3">
                  <label class="mb-1">ประเภทผู้ถือครอง:</label>
                  <treeselect
                    v-model="ownerType"
                    :multiple="true"
                    :options="ownerTypeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

             

            </div>
            <div class="row"> 

              <!-- Row 2 -->

                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
                <div class="form-group mb-3">
                  <label class="mb-1">ประเภทสินค้า:</label>
                  <treeselect
                    v-model="productType"
                    :multiple="true"
                    :options="productTypeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
                <div class="form-group mb-3">
                  <label class="mb-1">ชื่อสินค้า:</label>
                  <treeselect
                    v-model="materialCode"
                    :multiple="true"
                    :options="materialCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
                <div class="form-group mb-3">
                  <label class="mb-1">แบรนด์สินค้า:</label>
                  <treeselect
                    v-model="brand"
                    :multiple="true"
                    :options="brandOptions"
                    v-on:select="BrandIdClearAfterSelect"
                    v-on:deselect="BrandIdClearAfterDeSelect"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
                <div class="form-group mb-3">
                  <label class="mb-1">ชื่อแบรนด์สินค้า:</label>
                  <treeselect
                    id="ProductIdBrand"
                    v-model="productBrand"
                    :multiple="true"
                    :options="filteredProductBrandOptions"
                    placeholder="กรุณาเลือก"
                    ref="ProductIdBrand"
                  />
                </div>
              </div>

              <!-- Row 3 -->
              </div>
            <div class="row"> 

              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
                <div class="form-group mb-3">
                  <label class="mb-1">ช่วงคงค้าง:</label>
                  <treeselect
                    v-model="retentionPeriod"
                    :multiple="true"
                    :options="retentionPeriodOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

               <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
                <div class="form-group mb-3">
                  <label class="mb-1">สถานะ:</label>
                  <treeselect
                    v-model="barcodeStatusCode"
                    :multiple="true"
                    :options="barcodeStatusCodeOptions"
                    :clear-on-select="true"
                    placeholder="ถังเต็ม"
                  />
                </div>
              </div>
              
            </div>

             



            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button type="reset" class="btn btn-secondary" @click="formReset">
                  ล้างค่าทั้งหมด
                </button>
              </div>

              <div class="col-xl-6 text-right">
                <button 
                  class="btn btn-outline-primary mr-2"
                  @click="exportCompareReport"
                  type="button"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel (สำหรับตรวจสอบข้อมูล)</span>
                  </span>
                </button>
                <button
                  class="btn btn-outline-primary"
                  @click="exportReport"
                  type="button"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel (สรุปข้อมูลจากรายงาน)</span>
                  </span>
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!-- begin: Result Table -->
          <div class="row mt-0">
            <div class="col-xl-12 text-right" v-if="dataAsOfLabel">
              <span>{{ dataAsOfLabel }}</span>
            </div>
          </div>
          <div class="row mt-0">
            <div class="col-xl-12">
              <!-- Top scrollbar -->
              <div ref="topScrollWrapper" style="overflow-x:auto; overflow-y:hidden; height:20px;">
                <div ref="topScrollContent" style="height:1px;"></div>
              </div>
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap hide-full-sub hide-empty-sub hide-transit-sub"
                ref="stockOverdueTable"
                style="width: 100%"
              >
                <thead>
                  <tr>
                    <th rowspan="2">ประเภทผู้ถือครอง</th>
                    <th rowspan="2">ชื่อตัวแทนจำหน่าย</th>
                    <th rowspan="2">รหัสสินค้า</th>
                    <th rowspan="2">ชื่อสินค้า</th>
                    <th rowspan="2">รหัสแบรนด์สินค้า</th>
                    <th rowspan="2">ชื่อแบรนด์สินค้า</th>
                    <th colspan="4" class="text-center header-full">ถังเต็ม</th>
                    <th rowspan="2" class="text-center" style="cursor:pointer" @click="toggleGroup('full')">ถังเต็ม Total <i :class="groupVisible.full ? 'fa fa-minus-square' : 'fa fa-plus-square'" style="font-size:0.8em"></i></th>
                    <th colspan="4" class="text-center header-empty">ถังเปล่า</th>
                    <th rowspan="2" class="text-center" style="cursor:pointer" @click="toggleGroup('empty')">ถังเปล่า Total <i :class="groupVisible.empty ? 'fa fa-minus-square' : 'fa fa-plus-square'" style="font-size:0.8em"></i></th>
                    <th colspan="4" class="text-center header-transit">ระหว่างนำส่ง</th>
                    <th rowspan="2" class="text-center" style="cursor:pointer" @click="toggleGroup('transit')">ระหว่างนำส่ง Total <i :class="groupVisible.transit ? 'fa fa-minus-square' : 'fa fa-plus-square'" style="font-size:0.8em"></i></th>
                    <th rowspan="2" class="text-center">Grand Total</th>
                  </tr>
                  <tr>
                    <!-- ถังเต็ม sub -->
                    <th class="text-center sub-header sub-header-1 col-full-sub" style="background-color:#CCFFCC">ไม่เกิน 1 เดือน</th>
                    <th class="text-center sub-header sub-header-2 col-full-sub" style="background-color:#FFFDE1">ไม่เกิน 3 เดือน</th>
                    <th class="text-center sub-header sub-header-3 col-full-sub" style="background-color:#FCE4D6">ไม่เกิน 5 เดือน</th>
                    <th class="text-center sub-header sub-header-4 col-full-sub" style="background-color:#FFC7CE">เกิน 5 เดือน</th>
                    <!-- ถังเปล่า sub -->
                    <th class="text-center sub-header sub-header-1 col-empty-sub" style="background-color:#CCFFCC">ไม่เกิน 1 เดือน</th>
                    <th class="text-center sub-header sub-header-2 col-empty-sub" style="background-color:#FFFDE1">ไม่เกิน 3 เดือน</th>
                    <th class="text-center sub-header sub-header-3 col-empty-sub" style="background-color:#FCE4D6">ไม่เกิน 5 เดือน</th>
                    <th class="text-center sub-header sub-header-4 col-empty-sub" style="background-color:#FFC7CE">เกิน 5 เดือน</th>
                    <!-- ระหว่างนำส่ง sub -->
                    <th class="text-center sub-header sub-header-1 col-transit-sub" style="background-color:#CCFFCC">ไม่เกิน 1 เดือน</th>
                    <th class="text-center sub-header sub-header-2 col-transit-sub" style="background-color:#FFFDE1">ไม่เกิน 3 เดือน</th>
                    <th class="text-center sub-header sub-header-3 col-transit-sub" style="background-color:#FCE4D6">ไม่เกิน 5 เดือน</th>
                    <th class="text-center sub-header sub-header-4 col-transit-sub" style="background-color:#FFC7CE">เกิน 5 เดือน</th>
                  </tr>
                </thead>
                <tfoot>
                  <tr>
                    <th colspan="6" style="text-align:center">Grand Total</th>
                    <th class="col-full-sub"></th><th class="col-full-sub"></th><th class="col-full-sub"></th><th class="col-full-sub"></th><th></th>
                    <th class="col-empty-sub"></th><th class="col-empty-sub"></th><th class="col-empty-sub"></th><th class="col-empty-sub"></th><th></th>
                    <th class="col-transit-sub"></th><th class="col-transit-sub"></th><th class="col-transit-sub"></th><th class="col-transit-sub"></th><th></th>
                    <th></th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <!-- end: Result Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.header-full {
  background-color: #FFF2C6 !important;
  color: #000000 !important;
  font-size: 0.9em !important;
}
.header-empty {
  background-color: #C2E2FA !important;
  color: #000 !important;
  font-size: 0.9em !important;
}
.header-transit {
  background-color: #D4BEE4 !important;
  color: #000000 !important;
  font-size: 0.9em !important;
}
.sub-header {
  font-size: 0.6em !important;
}
.sub-header-1 {
  color: #00B050 !important; 
}
.sub-header-2 {
 color: #806000 !important;
}
.sub-header-3 {
  color: #C65911 !important;
}
.sub-header-4 {
 color: #E62727 !important;
}
.group-header {
  background-color: #ddd !important;
  font-weight: bold;
}
.group-header td.td-header {
  background-color: #f4f4f4 !important;
  font-weight: bold;
}
/* Collapse sub-columns */
.hide-full-sub .col-full-sub,
.hide-full-sub .header-full { display: none !important; }
.hide-empty-sub .col-empty-sub,
.hide-empty-sub .header-empty { display: none !important; }
.hide-transit-sub .col-transit-sub,
.hide-transit-sub .header-transit { display: none !important; }

/* Show bottom scrollbar */
.dataTables_scrollBody {
  overflow-x: auto !important;
}
.group-footer-sub td.td-footer {
  background-color: #f1efef !important;
  font-weight: bold;
  padding-left: 0 !important;
}
</style>

<script>
import axios from "axios";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  components: {
    Treeselect,
  },
  data: function () {
    return {
      dataTable: null,
      dataAsOfLabel: '',
      searchSource: null,
      groupVisible: { full: false, empty: false, transit: false },

      // Filter values
      headAgentCode: [],
      agentCode: [],
      productType: [],
      materialCode: [],
      productBrand: [],
      barcodeStatusCode: [],
      brand: [],
      ownerType: [],
      retentionPeriod: [],

      // Filter options
      headAgentCodeOptions: [],
      agentCodeOptions: [],
      productTypeOptions: [],
      materialCodeOptions: [],
      productBrandOptions: [],
      fullProductData: [],
      barcodeStatusCodeOptions: [],
      brandOptions: [],
      ownerTypeOptions: [],
      retentionPeriodOptions: [
        { id: "ไม่เกิน 1 เดือน", label: "ไม่เกิน 1 เดือน" },
        { id: "ไม่เกิน 3 เดือน", label: "ไม่เกิน 3 เดือน" },
        { id: "ไม่เกิน 5 เดือน", label: "ไม่เกิน 5 เดือน" },
        { id: "เกิน 5 เดือน", label: "เกิน 5 เดือน" },
      ],
    };
  },
  mounted: function () {
    this.loadHeadAgentCodeOptions();
    this.loadAgentCodeOptions();
    this.loadProductTypeOptions();
    this.loadMaterialCodeOptions();
    this.loadProductData();
    this.loadBarcodeStatusCodeOptions();
    this.loadBrandOptions();
    this.loadOwnerTypeOptions();
    this.initDataTable();
  },
  computed: {
    filteredProductBrandOptions: function () {
      if (!this.brand.length) {
        return this.productBrandOptions;
      }
      var selectedBrandIds = this.brand.map(Number);
      var filteredOptions = [];
      this.fullProductData.forEach(function (item) {
        if (selectedBrandIds.indexOf(item.data.productBrandId) !== -1) {
          filteredOptions.push({
            id: item.id,
            label: item.text,
            productBrandId: item.data.productBrandId,
          });
        }
      });
      return filteredOptions;
    },
  },
  methods: {
    // ชื่อตัวแทนจำหน่าย(Group)
    loadHeadAgentCodeOptions: function () {
      var self = this;
      axios
        .post(
          "/Api/Report/Select2Agent?companyType=COMPANY_PROFILE_TYPE_AGENT",
          { province_id: [], department: [], AgentCodes: [], page: 1, IsShowInAgentScoreReport: true, IsHead: true }
        )
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach(function (element) {
              self.headAgentCodeOptions.push({ id: element.id, label: element.text });
            });
          }
        })
        .catch(function () {});
    },

    // ชื่อตัวแทนจำหน่าย
    loadAgentCodeOptions: function () {
      var self = this;
      axios
        .post("/Api/Report/Select2Agent", {
          province_id: [], department: [], AgentCodes: [], page: 1, all: true, IsShowInAgentScoreReport: true,
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach(function (element) {
              self.agentCodeOptions.push({ id: element.id, label: element.text });
            });
          }
        })
        .catch(function () {});
    },

    // ประเภทสินค้า
    loadProductTypeOptions: function () {
      var self = this;
      axios
        .get("/Api/ProductType/Select2ProductType", { params: { page: 1, all: true } })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach(function (element) {
              if (element.id == 4 || element.id == 5) {
                self.productTypeOptions.push({ id: element.id, label: element.text });
              }
            });
          }
        })
        .catch(function () {});
    },

    // ชื่อสินค้า
    loadMaterialCodeOptions: function () {
      var self = this;
      axios
        .get("/Api/Product/Select2Product", {
          params: { page: 1, all: true, excludeProductGroupId: 14 },
        })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach(function (element) {
              self.materialCodeOptions.push({ id: element.id, label: element.text });
            });
          }
        })
        .catch(function () {});
    },

    // ชื่อแบรนด์สินค้า — โหลดข้อมูลทั้งหมดพร้อม productBrandId เพื่อใช้ filter ตามแบรนด์
    loadProductData: function () {
      var self = this;
      axios
        .post("/Api/product/Select2ProductReport", {
          page: 1,
          all: true,
          search: "",
          productGroupIds: [14],
        })
        .then(function (response) {
          if (response.status === 200) {
            self.fullProductData = response.data.results;
            self.productBrandOptions = self.fullProductData.map(function (item) {
              return {
                id: item.id,
                label: item.text,
                productBrandId: item.data.productBrandId,
              };
            });
          }
        })
        .catch(function (error) {
          console.error("Error loading product data:", error);
        });
    },

    // เคลียร์ ชื่อแบรนด์สินค้า เมื่อเลือก/ยกเลิก แบรนด์สินค้า
    BrandIdClearAfterSelect: function () {
      this.productBrand = [];
    },
    BrandIdClearAfterDeSelect: function () {
      this.productBrand = [];
    },

    // สถานะ
    loadBarcodeStatusCodeOptions: function () {
      var self = this;
      axios
        .get("/Api/Variables/Options?search=PRODUCT_BARCODE_STATUS", { params: { page: 1, all: true } })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach(function (element) {
              self.barcodeStatusCodeOptions.push({ id: element.id, label: element.text });
            });
          }
        })
        .catch(function () {});
    },

    // แบรนด์
    loadBrandOptions: function () {
      var self = this;
      axios
        .get("/Api/ProductBrand/Select2SearchBrandExistProduct", { params: { page: 1, all: true } })
        .then(function (response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach(function (element) {
              self.brandOptions.push({ id: element.id, label: element.text });
            });
          }
        })
        .catch(function () {});
    },

    // ประเภทผู้ถือครอง
    loadOwnerTypeOptions: function () {
      var self = this;
      var data = [
        { id: "ตัวแทนจำหน่าย",          label: "ตัวแทนจำหน่าย" },
        { id: "ตัวแทนจำหน่ายย่อย",      label: "ตัวแทนจำหน่ายย่อย" },
        { id: "ร้านค้า",                label: "ร้านค้า" },
        { id: "ร้านค้า (ตัวแทนฯย่อย)", label: "ร้านค้า (ตัวแทนฯย่อย)" },
      ];
      self.ownerTypeOptions = data;
    },

    toggleGroup: function (group) {
      this.groupVisible[group] = !this.groupVisible[group];
      var scrollBody = $(this.$refs.stockOverdueTable).closest('.dataTables_scrollBody');
      var scrollHead = scrollBody.prev('.dataTables_scrollHead');
      var scrollFoot = scrollBody.next('.dataTables_scrollFoot');
      var cssClass = 'hide-' + group + '-sub';

      var tables = $().add(scrollBody.find('table')).add(scrollHead.find('table')).add(scrollFoot.find('table'));

      if (this.groupVisible[group]) {
        tables.removeClass(cssClass);
      } else {
        tables.addClass(cssClass);
      }

      if (this.dataTable) {
        this.dataTable.columns.adjust();
      }

      // Sync top scrollbar width
      var self = this;
      self.$nextTick(function () {
        var topContent = self.$refs.topScrollContent;
        if (!topContent) return;
        var bodyTable = scrollBody.find('table');
        var headTable = scrollHead.find('table');
        var w = 0;
        if (bodyTable.length) w = Math.max(w, bodyTable[0].scrollWidth);
        if (headTable.length) w = Math.max(w, headTable[0].scrollWidth);
        topContent.style.width = w + 'px';
      });
    },

    formSubmit: function (e) {
      e.preventDefault();
      this.searchSource = "generate";
      if (this.dataTable) {
        this.dataTable.ajax.reload();
      } else {
        this.initDataTable();
      }
    },

    initDataTable: function () {
      var self = this;

      function calcRetentionRange(selected) {
        if (!selected || selected.length === 0) return { from: null, to: null };
        var rangeMap = {
          "ไม่เกิน 1 เดือน": { from: 1,   to: 30  },
          "ไม่เกิน 3 เดือน": { from: 31,  to: 90  },
          "ไม่เกิน 5 เดือน": { from: 91,  to: 150 },
          "เกิน 5 เดือน":    { from: 151, to: null },
        };
        var froms = [], tos = [], hasOpenEnd = false;
        selected.forEach(function(r) {
          var rng = rangeMap[r];
          if (!rng) return;
          froms.push(rng.from);
          if (rng.to !== null) { tos.push(rng.to); } else { hasOpenEnd = true; }
        });
        return {
          from: froms.length ? Math.min.apply(null, froms) : null,
          to:   hasOpenEnd ? null : (tos.length ? Math.max.apply(null, tos) : null),
        };
      }

      function formatNumber(val) {
        if (val === null || val === undefined || val === 0) return "-";
        return val.toLocaleString();
      }

      self.dataTable = $(self.$refs.stockOverdueTable).DataTable({
        scrollX: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/Report/SearchStockOverdue",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function (request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function (d) {
            var retentionRange = calcRetentionRange(self.retentionPeriod);
            var jsonSearch = {
              IsInitial: false,
              AgentCodes: self.agentCode,
              HeadAgentCodes: self.headAgentCode,
              AssetCodes: self.materialCode,
              ProductTypeIds: self.productType,
              BarcodeStatusCodes: self.barcodeStatusCode,
              FinishedProductCodes: self.productBrand,
              BrandIds: self.brand,
              CurrentLocationType: self.ownerType,
              OverDueFrom: retentionRange.from,
              OverDueTo: retentionRange.to,
              Source: self.searchSource,
            };
            self.searchSource = null;
            return JSON.stringify($.extend(d, jsonSearch));
          },
        },
        drawCallback: function () {
          var api = this.api();
          api.columns.adjust();
          var now = moment();
          self.dataAsOfLabel = 'ข้อมูล ณ วันที่ ' + now.format('DD/MM/YYYY h:mm a');

          // merge column 0 (ประเภทผู้ถือครอง) — rowspan เมื่อค่าซ้ำกัน
          var rows = api.rows({ page: 'current' }).nodes();
          var lastVal = null;
          var lastTd = null;
          var rowspanCount = 1;

          $(rows).each(function () {
            var td = $('td', this).eq(0);
            var val = td.text();
            if (val === lastVal && lastTd) {
              rowspanCount++;
              lastTd.attr('rowspan', rowspanCount);
              td.css('display', 'none');
            } else {
              lastVal = val;
              lastTd = td;
              rowspanCount = 1;
              td.attr('rowspan', 1);
              td.css('display', '');
            }
          });
        },
        dom: "<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>><'row'<'col-sm-12'tr>><'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>",
        lengthMenu: [50, 100, 200, 500],
        pageLength: 50,
        language: {
          lengthMenu: "Display _MENU_",
        },
        order: [[0, "asc"]],
        columns: [
          // ข้อมูลพื้นฐาน
          { data: "ownerType",       className: "text-left",   orderable: true },
          { data: "agentName",      className: "text-left",   orderable: true, render: function (data, type, row) { return '[' + (row.agentCode || '') + ']  ' + (data || ''); } },
          { data: "assetCode",       className: "text-center", orderable: true },
          { data: "assetName",       className: "text-left",   orderable: false },
          { data: "brandCode",       className: "text-center", orderable: false },
          { data: "brandName",       className: "text-left",   orderable: false },
          // ถังเต็ม
          { data: "full_1Month",     className: "text-center col-full-sub", orderable: false, render: function (data) { return formatNumber(data); } },
          { data: "full_3Month",     className: "text-center col-full-sub", orderable: false, render: function (data) { return formatNumber(data); } },
          { data: "full_5Month",     className: "text-center col-full-sub", orderable: false, render: function (data) { return formatNumber(data); } },
          { data: "full_Over5Month", className: "text-center col-full-sub", orderable: false, render: function (data) { return formatNumber(data); } },
          { data: "full_Total",      className: "text-center font-weight-bold", orderable: false, render: function (data) { return formatNumber(data); } },
          // ถังเปล่า
          { data: "empty_1Month",     className: "text-center col-empty-sub", orderable: false, render: function (data) { return formatNumber(data); } },
          { data: "empty_3Month",     className: "text-center col-empty-sub", orderable: false, render: function (data) { return formatNumber(data); } },
          { data: "empty_5Month",     className: "text-center col-empty-sub", orderable: false, render: function (data) { return formatNumber(data); } },
          { data: "empty_Over5Month", className: "text-center col-empty-sub", orderable: false, render: function (data) { return formatNumber(data); } },
          { data: "empty_Total",      className: "text-center font-weight-bold", orderable: false, render: function (data) { return formatNumber(data); } },
          // ระหว่างนำส่ง
          { data: "transit_1Month",     className: "text-center col-transit-sub", orderable: false, render: function (data) { return formatNumber(data); } },
          { data: "transit_3Month",     className: "text-center col-transit-sub", orderable: false, render: function (data) { return formatNumber(data); } },
          { data: "transit_5Month",     className: "text-center col-transit-sub", orderable: false, render: function (data) { return formatNumber(data); } },
          { data: "transit_Over5Month", className: "text-center col-transit-sub", orderable: false, render: function (data) { return formatNumber(data); } },
          { data: "transit_Total",      className: "text-center font-weight-bold", orderable: false, render: function (data) { return formatNumber(data); } },
          // Grand Total
          { data: "grandTotal",         className: "text-center font-weight-bold", orderable: false, render: function (data) { return formatNumber(data); } },
        ],
        rowGroup: {
          dataSrc: function (row) {
            return row.ownerType || "(ไม่ระบุ)";
          },
          startRender: function (rows, group) {
            return $('<tr class="group-header"/>').append(
              '<td colspan="22" class="td-header">' + group + "</td>"
            );
          },
          endRender: function (rows, group) {
            var colDefs = [
              { key: "full_1Month",      cls: "col-full-sub" },
              { key: "full_3Month",      cls: "col-full-sub" },
              { key: "full_5Month",      cls: "col-full-sub" },
              { key: "full_Over5Month",  cls: "col-full-sub" },
              { key: "full_Total",       cls: "" },
              { key: "empty_1Month",     cls: "col-empty-sub" },
              { key: "empty_3Month",     cls: "col-empty-sub" },
              { key: "empty_5Month",     cls: "col-empty-sub" },
              { key: "empty_Over5Month", cls: "col-empty-sub" },
              { key: "empty_Total",      cls: "" },
              { key: "transit_1Month",     cls: "col-transit-sub" },
              { key: "transit_3Month",     cls: "col-transit-sub" },
              { key: "transit_5Month",     cls: "col-transit-sub" },
              { key: "transit_Over5Month", cls: "col-transit-sub" },
              { key: "transit_Total",      cls: "" },
              { key: "grandTotal",         cls: "" }
            ];
            var sums = {};
            colDefs.forEach(function(d) {
              sums[d.key] = rows.data().pluck(d.key).reduce(function (a, b) { return a + Number(b); }, 0);
            });

            var tr = $('<tr class="group-footer-sub"/>');
            tr.append('<td class="td-footer" colspan="6" style="max-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">' + group + ' Total</td>');
            colDefs.forEach(function(d) {
              tr.append('<td class="td-footer text-center ' + d.cls + '">' + formatNumber(sums[d.key]) + "</td>");
            });
            return tr;
          },
        },
        footerCallback: function () {
          var api = this.api();
          var json = api.ajax.json();
          if (!json || !json.groupSummary) {
            for (var i = 6; i <= 21; i++) {
              $(api.column(i).footer()).html("");
            }
            return;
          }
          var s = json.groupSummary;
          var footerCols = [
            "tot_Full_1Month","tot_Full_3Month","tot_Full_5Month","tot_Full_Over5Month","tot_Full_Total",
            "tot_Empty_1Month","tot_Empty_3Month","tot_Empty_5Month","tot_Empty_Over5Month","tot_Empty_Total",
            "tot_Transit_1Month","tot_Transit_3Month","tot_Transit_5Month","tot_Transit_Over5Month","tot_Transit_Total",
            "tot_GrandTotal"
          ];
          for (var i = 0; i < footerCols.length; i++) {
            $(api.column(6 + i).footer()).html(formatNumber(s[footerCols[i]]));
          }
        },
      });

      // Apply default collapse
      self.$nextTick(function () {
        var scrollBody = $(self.$refs.stockOverdueTable).closest('.dataTables_scrollBody');
        var scrollHead = scrollBody.prev('.dataTables_scrollHead');
        var scrollFoot = scrollBody.next('.dataTables_scrollFoot');
        var tables = $().add(scrollBody.find('table')).add(scrollHead.find('table')).add(scrollFoot.find('table'));
        tables.addClass('hide-full-sub hide-empty-sub hide-transit-sub');
        if (self.dataTable) self.dataTable.columns.adjust();
      });

      // Sync top scrollbar with DataTables scrollBody
      self.$nextTick(function () {
        var scrollBody = $(self.$refs.stockOverdueTable).closest('.dataTables_scrollBody');
        var topWrapper = self.$refs.topScrollWrapper;
        var topContent = self.$refs.topScrollContent;
        if (!scrollBody.length || !topWrapper || !topContent) return;

        function syncTopScrollWidth() {
          var bodyTable = scrollBody.find('table');
          var headTable = scrollBody.prev('.dataTables_scrollHead').find('table');
          var w = 0;
          if (bodyTable.length) w = Math.max(w, bodyTable[0].scrollWidth);
          if (headTable.length) w = Math.max(w, headTable[0].scrollWidth);
          topContent.style.width = w + 'px';
        }
        syncTopScrollWidth();

        var syncing = false;
        $(topWrapper).on('scroll', function () {
          if (syncing) return;
          syncing = true;
          scrollBody[0].scrollLeft = topWrapper.scrollLeft;
          syncing = false;
        });
        scrollBody.on('scroll', function () {
          if (syncing) return;
          syncing = true;
          topWrapper.scrollLeft = scrollBody[0].scrollLeft;
          syncing = false;
        });

        // Update width on draw (e.g. column toggle)
        $(self.$refs.stockOverdueTable).on('draw.dt', function () {
          self.$nextTick(function () { syncTopScrollWidth(); });
        });
      });
    },

    exportCompareReport: function (e) {
      e.preventDefault();
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      function calcRetentionRange(selected) {
        if (!selected || selected.length === 0) return { from: null, to: null };
        var rangeMap = {
          "ไม่เกิน 1 เดือน": { from: 1,   to: 30  },
          "ไม่เกิน 3 เดือน": { from: 31,  to: 90  },
          "ไม่เกิน 5 เดือน": { from: 91,  to: 150 },
          "เกิน 5 เดือน":    { from: 151, to: null },
        };
        var froms = [], tos = [], hasOpenEnd = false;
        selected.forEach(function(r) {
          var rng = rangeMap[r];
          if (!rng) return;
          froms.push(rng.from);
          if (rng.to !== null) { tos.push(rng.to); } else { hasOpenEnd = true; }
        });
        return {
          from: froms.length ? Math.min.apply(null, froms) : null,
          to:   hasOpenEnd ? null : (tos.length ? Math.max.apply(null, tos) : null),
        };
      }

      var retentionRange = calcRetentionRange(self.retentionPeriod);

      axios({
        method: "post",
        url: "/Api/Report/ExportCompareSnapshotVsBarcode",
        responseType: "arraybuffer",
        headers: {
          Authorization: "Bearer " + self.$root.user.access_token,
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          IsInitial: false,
          AgentCodes: self.agentCode,
          HeadAgentCodes: self.headAgentCode,
          AssetCodes: self.materialCode,
          ProductTypeIds: self.productType,
          BarcodeStatusCodes: self.barcodeStatusCode,
          FinishedProductCodes: self.productBrand,
          BrandIds: self.brand,
          CurrentLocationType: self.ownerType,
          OverDueFrom: retentionRange.from,
          OverDueTo: retentionRange.to,
          Source: "export",
        }),
      })
        .then(function (response) {
          KTApp.unblockPage();
          var blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download =
            moment().format("YYYY-MM-DD") +
            "_รายงานStockระบบเบียร์สด(ตรวจสอบข้อมูล).xlsx";
          link.click();
        })
        .catch(function () {
          KTApp.unblockPage();
        });
    },

    exportReport: function (e) {
      e.preventDefault();
      var self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      function calcRetentionRange(selected) {
        if (!selected || selected.length === 0) return { from: null, to: null };
        var rangeMap = {
          "ไม่เกิน 1 เดือน": { from: 1,   to: 30  },
          "ไม่เกิน 3 เดือน": { from: 31,  to: 90  },
          "ไม่เกิน 5 เดือน": { from: 91,  to: 150 },
          "เกิน 5 เดือน":    { from: 151, to: null },
        };
        var froms = [], tos = [], hasOpenEnd = false;
        selected.forEach(function(r) {
          var rng = rangeMap[r];
          if (!rng) return;
          froms.push(rng.from);
          if (rng.to !== null) { tos.push(rng.to); } else { hasOpenEnd = true; }
        });
        return {
          from: froms.length ? Math.min.apply(null, froms) : null,
          to:   hasOpenEnd ? null : (tos.length ? Math.max.apply(null, tos) : null),
        };
      }

      var retentionRange = calcRetentionRange(self.retentionPeriod);

      axios({
        method: "post",
        url: "/Api/Report/ExportStockOverdue",
        responseType: "arraybuffer",
        headers: {
          Authorization: "Bearer " + self.$root.user.access_token,
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          IsInitial: false,
          AgentCodes: self.agentCode,
          HeadAgentCodes: self.headAgentCode,
          AssetCodes: self.materialCode,
          ProductTypeIds: self.productType,
          BarcodeStatusCodes: self.barcodeStatusCode,
          FinishedProductCodes: self.productBrand,
          BrandIds: self.brand,
          CurrentLocationType: self.ownerType,
          OverDueFrom: retentionRange.from,
          OverDueTo: retentionRange.to,
          Source: "export",
        }),
      })
        .then(function (response) {
          KTApp.unblockPage();
          var blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          // link.download =
          //   "รายงานStockระบบเบียร์สด_" +
          //   moment().format("DDMMYYYY") +
          //   ".xlsx";
              link.download =
             moment().format("YYYY-MM-DD") +"_รายงานStockระบบเบียร์สด"+
            ".xlsx";
          link.click();
        })
        .catch(function () {
          KTApp.unblockPage();
        });
    },

    formReset: function () {
      this.headAgentCode = [];
      this.agentCode = [];
      this.productType = [];
      this.materialCode = [];
      this.productBrand = [];
      this.barcodeStatusCode = [];
      this.brand = [];
      this.ownerType = [];
      this.retentionPeriod = [];
      this.dataAsOfLabel = '';

      if (this.dataTable) {
        this.dataTable.destroy();
        this.dataTable = null;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// App/Components/Report/AgentStockOverdue.vue